// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1GBFo","productName":"Table_productName__3kooT"};